var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('load-area',{attrs:{"loadareadata":_vm.LoadAreaData,"timestamp":_vm.CurrentTimestamp,"application":this.$store.state.application}}),_vm._v(" "),(_vm.$gate.isAdmin())?_c('api-log',{ref:"requestlog",attrs:{"limit":10,"paginate":true}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }